import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { NgkAuthGuardService, NgkAuthService } from '@kin/ngk-auth';

import { PlatformAuthStore } from './auth.store';

/**
 * Route guard for platform routes requiring an authenticated Keycloak session.
 *
 * If the session is inactive, redirects to /platform/login.
 * If the session is active, defers to NgkAuthGuardService to check if the user has the required roles for the route.
 * If no roles are specified on the route, the user just needs to be authenticated to access the route.
 */
export const canActivatePlatformRoute: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authStore = inject(PlatformAuthStore);
  const authService = inject(NgkAuthService);
  const authGuardService = inject(NgkAuthGuardService);
  const router = inject(Router);

  if (!authStore.isLoggedIn()) {
    return router.parseUrl('/platform/login');
  }

  return authGuardService.canActivate(authService, router, route);
};
